module.exports = __webpack_public_path__ + "static/media/TimeAndMoney2.ab64e18e.png";